// Derived-state selectors over the session slice (ARCHITECTURE §7).
export const selectIsAuthenticated = (state) => Boolean(state.session?.user);
export const selectCurrentUser = (state) => state.session?.user ?? null;
export const selectSessionChecked = (state) => Boolean(state.session?.sessionChecked);
